export const getDocumentIDsFromLocalStorage = () => {
  return localStorage.getItem('documentIDs');
};

export const setDocumentIDsInLocalStorage = (ids: string[]) => {
  localStorage.setItem('documentIDs', JSON.stringify(ids));
};

export const getDocumentGroupsFromLocalStorage = () => {
  try {
    const raw = localStorage.getItem('documentGroups');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const setDocumentGroupsInLocalStorage = (groups: any[]) => {
  localStorage.setItem('documentGroups', JSON.stringify(groups));
};
